'use client';

import React from 'react';

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselControls,
} from '@/components/ui/carousel';
import { CardBlog } from '@/components/CardBlog';
import { NAV } from '@/constants';
import type { Post } from '@/payload-types';

export const BlogSlider: React.FC<{
  title: string;
  posts: Post[];
}> = ({ title, posts }) => {
  const objectPosts = posts.filter((i) => typeof i === 'object');

  return (
    <section className="v-margin" data-name="BlogSlider">
      <div className="container">
        <h2 className="h2 mb-10 md:mb-6">{title}</h2>

        <Carousel opts={{ align: 'start', loop: true }}>
          <CarouselContent className="-ml-6 lg:-ml-4">
            {objectPosts.map((doc) => (
              <CarouselItem
                className="flex basis-1/3 pb-0.5 pl-5 md:basis-full md:pl-4"
                key={doc.id}
              >
                <CardBlog doc={doc} />
              </CarouselItem>
            ))}
          </CarouselContent>

          <CarouselControls linkText="Все статьи" linkUrl={NAV.blogList()} />
        </Carousel>
      </div>
    </section>
  );
};
